// Module
var code = "<div class=\"mx-repeater\" flex>\r\n\t<div flex class=\"mx-repeater--row\" ng-repeat=\"item in (__$vm.entities || []) | orderBy:__$vm.orderBy:__$vm.reverse\">\r\n\t\t<div class=\"mx-repeater--panel\" flex ng-include src=\"__$vm.templateId\">\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n";
// Exports
export default code;